import { message } from 'antd';
import {
  GET_TICKET_BY_ID_URL ,
  CANCEL_TICKET_URL ,
  UPDATE_TICKET_URL,
  OVER_RIDE_PENALITY_URL,
  SEND_UPDATED_TICKET_MAIL_URL,
  SEND_UPDATED_TICKET_SMS_URL,
  GET_TICKET_BY_PNR_URL,
  GET_REFUND_ARN_BY_ORDER_ID, ISSUE_PG_REFUND_URL,
  UPDATE_TRAVELLER_BOARDED_STATUS_URL,
  CONFIRM_PG_TICKET_URL,
  FETCH_PG_TRANSACTION_LOGS_URL,
  VALIDATE_TICKET_IMPORT_URL,
  BULK_BOOK_IMPORTED_TICKETS_URL,
  BULK_RELEASE_IMPORTED_TICKETS_URL
} from './../utils/api-url';
import { postCall } from './../utils/network.util';
import { RESET_PASSENGER_FORM } from './action-types';

export const updateTravellerBoardedStatus=(travellerId,onSuccess=()=>{},onFailure=()=>{})=>{
  fetch(UPDATE_TRAVELLER_BOARDED_STATUS_URL, {
    method: "POST",
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({"travellerId" : travellerId,"boardedStatus":true})
  })
  .then(response => response.json())
  .then(response => {
    if(response.Status==="FAILURE"){
      message.error(response.Message);
    }else{
      onSuccess(response);
    }
  })
  .catch((reason)=> {
      message.error(`Failed to update traveller boarded status as ${reason}`);
  });
}

export const cancelTicket=(ticket,travellers,partialCancelStatus,sendCancellationNotification,cancellationPenality,isTravelBoarded=true,onSuccess=()=>{})=>{
  ticket['agent_id'] = global.agentId;
  return fetch(CANCEL_TICKET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"ticket" : {
                  id:ticket.id,
                  trip_id:ticket.trip_id,
                  trip_route_id:ticket.trip_route_id,
                  agent_id:ticket.agent_id        
                },
                "travellers" : travellers,
                "userName" : global.userName,
                "partialCancel" : partialCancelStatus,
                "operatorCode" : global.operatorCode,
                "sendCancellationNotification" : sendCancellationNotification,
                "cancellationPenalityPercentage":cancellationPenality ,
                "agentId":global.agentId,
                "isTravelBoarded":isTravelBoarded,
                "fromAgentPortal":true
            })
         })
        .then(response => response.json())
        .then(response => {
            if(response === true){
            message.success("Ticket cancelled successfully!");
            onSuccess()
            return true;
        }
        else{
          message.error(`Ticket cancellation failed because of ${response}`);
            return false;
        }
        })
        .catch((reason)=> {
            message.error(`Ticket cancellation failed because of ${reason}`)
            return false;
        }); 
}



export const getTicketById=(ticketId,onSuccess=()=>{},onFailure=()=>{})=>{
    fetch(GET_TICKET_BY_ID_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"ticketId" : ticketId})
        })
        .then(response => response.json())
        .then(response => {
            if(response.Status==="FAILURE"){
                message.error(response.Message);
            }else{
                onSuccess(response);
            }
        })
        .catch((reason)=> {
            message.error(`Ticket fecthing failed because of ${reason}`)   
            onFailure()     
        }); 
}

export const updateTransactionDetails=(transactionDetails,onSuccess=()=>{},onFailure=()=>{})=>{
    let ticket = {};
    let isSeatTaken = {};
    ticket.id = transactionDetails.ticket.id;
    ticket.phoneNumber = transactionDetails.ticket.phone_number;
    ticket.trip_id = transactionDetails.trip.id;
    ticket.trip_route_id = transactionDetails.ticket.trip_route_id;
    ticket.emailId = transactionDetails.ticket.email_id;
    ticket.updated_by = global.userName;
    ticket.remarks = transactionDetails.ticket.remarks;
    ticket.dropLocationId = transactionDetails.ticket.drop_location;

    let seats = [] , isErrorExtraSeat = false;
    let travellers = transactionDetails.traveller.map((traveller)=>{
      if(traveller.traveller_status == 'Cancelled'){
        return;
      }else{
        if (isSeatTaken[traveller.seat_number]){
          message.error("Please select different seats");
          isErrorExtraSeat = true;
          return;
        // }else if (traveller.traveller_status !== 'Confirmed') {
        //   return;
        }else{
          let seat = {};
          seat.ticket_id = transactionDetails.ticket.id;
          seat.seatNumber = traveller.seat_number;
          seat.tripId = transactionDetails.trip.id;
          seats.push(seat);
          let temptraveller = {};
          temptraveller.id = traveller.id;
          temptraveller.fullName = traveller.full_name;
          temptraveller.pickup_location = traveller.pickup_location.id;
          temptraveller.gender = traveller.gender;
          temptraveller.seatNumber = traveller.seat_number;
          if(traveller.seat_number!="extra"){
            isSeatTaken[traveller.seat_number] = true;
          }
          return temptraveller;
        }
      }
    });
    if(isErrorExtraSeat){
      onFailure("Please select different seats");
    }else{
    var filteredTravellers = travellers.filter(function (el) {
      return el != null;
    });
    fetch(UPDATE_TICKET_URL, {
      method: "POST",
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({"ticket" : ticket,
      "travellers" : filteredTravellers,
      "seats" : seats,
      "websiteUpdate" : false})
      })
      .then((response) => {return response.json()})
      .then((data) => {
        if(data.Status === "SUCCESS"){
        message.success('Ticket details updated successfully');
        onSuccess()
      }
      else{
        message.error(`Ticket Updation failed because of ${data.Message}`);
        onFailure()
      }
      })
      .catch((error)=>{
        message.error(`Ticket updation failed. Please try again ${error}`);
      })
    }
  }

  export const overRidePenality=(travellerIds,penalty,onSuccess=()=>{},onFailure=()=>{})=>{
    return fetch(OVER_RIDE_PENALITY_URL, {
      method: "POST",
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ travellerIds,penalty})
      })
      .then(response => response.json())
      .then(response => {
          if(response.Status==="FAILURE"){
              message.error(response.Message);
          }else{
              onSuccess(response);
              return true;
          }
      })
      .catch((reason)=> {
          message.error(`Ticket fecthing failed because of ${reason}`)   
          onFailure()     
      }); 
  }

  export const resetPassengerForm=()=>{
    return {
      type: RESET_PASSENGER_FORM
    }
  }

  export const sendTicketUpdateMailById=(ticketId,onSuccess=()=>{},onFailure=()=>{})=>{
    fetch(SEND_UPDATED_TICKET_MAIL_URL, {
      method: "POST",
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({"ticketId" : ticketId})
    })
    .then(response => response.json())
    .then(response => {
        if(response.Status===false){
            onFailure(response.message);
        }else{
            onSuccess(response.message);
        }
    })
    .catch((reason)=> {
        onFailure("Failed to send mail")     
    }); 
  }

  export const sendTicketUpdateSMSById=(ticketId,onSuccess=()=>{},onFailure=()=>{})=>{
    fetch(SEND_UPDATED_TICKET_SMS_URL, {
      method: "POST",
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({"ticketId" : ticketId})
    })
    .then(response => response.json())
    .then(response => {
        if(response.Status===false){
            onFailure(response.message);
        }else{
          onSuccess(response.message);
        }
    })
    .catch((reason)=> {
        onFailure("Failed to send SMS")     
    }); 
  }

export const fetchTicketDetailsByPNR=(pnr,onSuccess, onFailure=()=>{})=>{
  fetch(GET_TICKET_BY_PNR_URL, {
    method: "POST",
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({"pnr" : pnr ,"operatorCode":global.operatorCode,"agentId":global.agentId,getLogs:true,getStatusOfSeat:true})
  })
  .then(response => response.json())
  .then(transactionDetails => {
    if (transactionDetails.Message === "Unable to get ticket details"||transactionDetails.Message === "PNR not found"||transactionDetails.Status==="FAILURE"){
      message.error("Please enter a valid PNR");
      onFailure(transactionDetails.Message)
    }
    else{
      onSuccess(transactionDetails);
    }
  })
}


export const getRefundARNByOrderId=(orderId,onSuccess=()=>{}) =>{
  fetch(GET_REFUND_ARN_BY_ORDER_ID, {
    method: "POST",
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({"orderRefNo" : orderId, operatorCode: global.operatorCode})
  })
  .then(response => response.json())
  .then(response => {
      if(response.Status==="FAILURE"){
          message.error(response.Message);
      }else{
          onSuccess(response);
      }
  })
  .catch((reason)=> {
      message.error(`Failed to fetch refund ARN as ${reason}`);
  });
}

export const issuePGRefundAction=(referenceId, refundAmount, refundNote, paymentOrderId, operatorCode, ticketId, pnr, onSuccess=()=>{}) => {
  fetch(ISSUE_PG_REFUND_URL, {
    method: "POST",
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({referenceId, refundAmount, refundNote, paymentOrderId, operatorCode, ticketId, pnr})
  })
  .then(response => response.json())
  .then(response => {
      if(response.Status==="FAILURE"){
          message.error(response.Message);
      }else{
          onSuccess(response);
      }
  })
  .catch((reason)=> {
      message.error(`Failed to issue refund as ${reason}`);
  });
}

export const updateTicketForExtraSeats = (ticketData, onSuccess=()=>{}, onFailure=()=>{})=>{
  fetch(UPDATE_TICKET_URL, {
    method: "POST",
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({...ticketData})
  })
  .then(response => response.json())
  .then(response => {
      if(response.Status==="FAILURE"){
          message.error(response.Message);
      }else{
          onSuccess(response);
  }
  })
  .catch((reason)=> {
      message.error(`Failed to update ticket for extra seats as ${reason}`);
  });
}

export const confirmPGTicketAction=(ticketId, onSuccess=()=>{}) => {
  fetch(CONFIRM_PG_TICKET_URL, {
    method: "POST",
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({ticketId, updatedBy: global.userName})
  })
  .then(response => response.json())
  .then(response => {
    if(response.Status==="FAILURE"){
      message.error(response.Message);
    }else{
      onSuccess(response);
    }
  })
}

export const fetchPGTransactionsLogsAction=(orderReferenceNo,onSuccess=()=>{}, onFailure=()=>{})=>{
  fetch(FETCH_PG_TRANSACTION_LOGS_URL, {
    method: "POST",
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({"orderRefNo" : orderReferenceNo, "operatorCode": global.operatorCode})
  })
  .then(response => response.json())
  .then(response => {
    if(response.Status==="FAILURE"){
      message.error(response.Message);
    }else{
      onSuccess(response);
    }
  })
  .catch((reason)=> {
    message.error(`Failed to fetch PG transactions logs as ${reason}`);
    onFailure();
  });
}

// =============================================================================
// Ticket Import actions — validation, bulk booking and bulk release of a
// Data Backup Export Report. Same pattern as admin.action.js
// (getSystemInfo, getCancellationPolicyByOperatorCode, etc.): postCall +
// (onSuccess, onFailure) callbacks. postCall auto-injects operatorCode /
// agentId / userName from globals, so callers only forward the parsed
// payload data.
// =============================================================================

/*
  Validate the parsed file rows against existing trips. onSuccess receives
  the validation Payload (summary + per-ticket results + cancellation
  lookups).
*/
export const validateTicketImport = (trips, cancellations, onSuccess, onFailure) => {
    return postCall(VALIDATE_TICKET_IMPORT_URL, {
        trips: trips,
        cancellations: cancellations,
    }).then((data) => {
        if (data.status === "SUCCESS") {
            if (data.payload.Status === "SUCCESS") {
                onSuccess(data.payload.Payload);
            } else {
                const reason = data.payload.Message || "Failed to validate ticket import";
                message.error(reason);
                onFailure(reason);
            }
        } else {
            onFailure("Failed to validate ticket import");
        }
    }).catch((reason) => {
        console.log({ reason });
        message.error(`Failed to validate ticket import: ${reason}`);
        onFailure(reason);
    });
}

/*
  Bulk-book the importable rows. onSuccess receives the booking summary +
  per-ticket results.
*/
export const bulkBookImportedTickets = (trips, onSuccess, onFailure) => {
    return postCall(BULK_BOOK_IMPORTED_TICKETS_URL, {
        trips: trips,
    }).then((data) => {
        if (data.status === "SUCCESS") {
            if (data.payload.Status === "SUCCESS") {
                onSuccess(data.payload.Payload);
            } else {
                const reason = data.payload.Message || "Failed to bulk book tickets";
                message.error(reason);
                onFailure(reason);
            }
        } else {
            onFailure("Failed to bulk book tickets");
        }
    }).catch((reason) => {
        console.log({ reason });
        message.error(`Failed to bulk book tickets: ${reason}`);
        onFailure(reason);
    });
}

/*
  Release previously-imported tickets matched by remarks PNR. onSuccess
  receives the release summary + per-row results.
*/
export const bulkReleaseImportedTickets = (cancellations, onSuccess, onFailure) => {
    return postCall(BULK_RELEASE_IMPORTED_TICKETS_URL, {
        cancellations: cancellations,
    }).then((data) => {
        if (data.status === "SUCCESS") {
            if (data.payload.Status === "SUCCESS") {
                onSuccess(data.payload.Payload);
            } else {
                const reason = data.payload.Message || "Failed to release tickets";
                message.error(reason);
                onFailure(reason);
            }
        } else {
            onFailure("Failed to release tickets");
        }
    }).catch((reason) => {
        console.log({ reason });
        message.error(`Failed to release tickets: ${reason}`);
        onFailure(reason);
    });
}